@if (variant() === 'solid') {
  <span [class]="hostClasses()" role="img" [attr.aria-label]="label()">
    <i class="fa-solid fa-hexagon-nodes" aria-hidden="true"></i>
    {{ label() }}
  </span>
} @else {
  <span
    class="tier-badge--outline-wrapper"
    [class.tier-badge--outline-wrapper--pro]="tier === 'pro'"
    [class.tier-badge--outline-wrapper--sm]="size() === 'sm'"
    [class.tier-badge--outline-wrapper--lg]="size() === 'lg'"
  >
    <span [class]="hostClasses()" role="img" [attr.aria-label]="label()">
      <span class="tier-badge__gradient-content">
        <i class="fa-solid fa-hexagon-nodes" aria-hidden="true"></i>
        {{ label() }}
      </span>
    </span>
  </span>
}
